/**
 * Chooses full AppLayout for signed-in completed profiles, or ShareGuestChrome
 * for shared /posts/:id and /profile/:username entry points.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated, selectProfileComplete, selectAuthLoading } from '../../store/auth.reducer';
import Loading from '../Loading/Loading';
import AppLayout from './AppLayout';
import ShareGuestChrome from './ShareGuestChrome';

function ShareSurfaceLayout() {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const profileComplete = useSelector(selectProfileComplete);
  const loading = useSelector(selectAuthLoading);

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated || !profileComplete) {
    return (
      <ShareGuestChrome>
        <Outlet />
      </ShareGuestChrome>
    );
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

export default ShareSurfaceLayout;
